import { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpand, faTimes } from '@fortawesome/free-solid-svg-icons';
import shared from '@lib/components';

const {
  Button,
} = shared;


const WEEK_MS = 7 * 24 * 60 * 60 * 1000;
const gamePath = '/house-games/';
const htmlFile = '/index.html';
const iFrameId = 'iog-mini-header-game';
const overlayId = 'mini-game-overlay';

const baseSchedule = [
  'mr-sword',       // 0 Sun
  'roidz',          // 1 Mon
  'pixel-jumper',   // 2 Tue
  'color-match',    // 3 Wed
  'rock-skipper',   // 4 Thu
  null,             // 5 Fri (decided by parity/param)
  'pixel-jumper',   // 6 Sat
];

// Deterministic parity: flips each 7-day bucket since Unix epoch (Thu 00:00 UTC boundary)
function fridayByParityEpoch() {
  const weeksSinceEpoch = Math.floor(Date.now() / WEEK_MS);
  return weeksSinceEpoch % 2 === 0 ? 'color-match' : 'rock-skipper';
}

// Parse ?miniGameWeek=...
function parseFridayOverride(value) {
  if (!value) return null;
  const v = String(value).toLowerCase().trim();

  if (v === 'color-match' || v === 'rock-skipper') return v;
  if (v === 'even' || v === '0') return 'color-match';
  if (v === 'odd'  || v === '1') return 'rock-skipper';

  return null; // invalid → ignore
}

function parseDayOverride(value) {
  if (value == null) return null;
  const n = Number(value);
  if (Number.isInteger(n) && n >= 0 && n <= 6) return n;
  return null;
}

const FullScreenButton = () => {
	const [isFullScreen, setIsFullScreen] = useState(false);
	
	useEffect(() => {
	  const overlay = document.getElementById(overlayId);
	  if (overlay) {
		overlay.classList.toggle('full-screen', isFullScreen);
		document.body.style.overflow = isFullScreen ? 'hidden' : '';
	  }
	}, [isFullScreen]);
  
	const icon = isFullScreen ? faTimes : faExpand;
	
	const handleFullScreen = () => {
	  setIsFullScreen(!isFullScreen);
	}
  
	return (
	  <Button  className="full-screen-button" small primary onClick={handleFullScreen}>
		<FontAwesomeIcon icon={icon} />
	  </Button>
	);
  }

export default function MiniHeaderGames() {
  const [dayIndex, setDayIndex] = useState(() => new Date().getDay());
  const [fridaySlug, setFridaySlug]   = useState(() => fridayByParityEpoch());
  // Read URL params client-side and apply overrides
  useEffect(() => {
    if (typeof window === 'undefined') return;
	
    const params = new URLSearchParams(window.location.search);

    const dayOverride = parseDayOverride(params.get('miniGameDay'));
    if (dayOverride !== null) setDayIndex(dayOverride);

    const weekOverride = parseFridayOverride(params.get('miniGameWeek'));
    if (weekOverride) setFridaySlug(weekOverride);

    // Expose debug hooks
    window.updateDayForHeaderGame = (idx) => {
      const n = Number(idx);
      if (Number.isInteger(n) && n >= 0 && n <= 6) setDayIndex(n);
    };
    window.updateFridayGame = (slug) => {
      const parsed = parseFridayOverride(slug);
      if (parsed) setFridaySlug(parsed);
    };
  }, []);

  // Resolve the game for the selected day
  let gameSlug = baseSchedule[dayIndex] ?? null;

  if (dayIndex === 5) {
    // Friday: URL override > parity default
    gameSlug = fridaySlug || fridayByParityEpoch();
  }

  // Final fallback: if something went wrong, show a safe default
  if (typeof gameSlug !== 'string') gameSlug = 'pixel-jumper';

  const fullGameUrl = `${gamePath}${gameSlug}${htmlFile}`;

  return (
	<div className="mini-game-overlay" id={overlayId}>

		<div className="mini-game-overlay-content">
			<FullScreenButton />
			<iframe
			id={iFrameId}
			src={fullGameUrl}
			type="text/html"
			style={{ width: '750px', height: '100px', margin: '0 1rem', border: 'none' }}
		/>
		</div>
	</div>
  );
}


// background: rgba(0, 0, 0, .6);
// height: 100vh;
// width: 100vw;
// position: absolute;
// top: 0;
// left: 0;
// z-index: 4;